import {useState} from 'react';
import isNumber from 'lodash/isNumber';
import omit from 'lodash/omit';

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

import CustomInput from "./CustomInput";
import {formatCurrency}  from '../../helpers/currency';

const handleChange = ({onChange, setValue}) => e => {
  const input = e.target.value;
  // Strip out commas or dollar signs
  const cleanInput = input.replace(/[^0-9.]/g, '');
  // Prevent multiple decimals
  const parts = cleanInput.split(".");
  if (parts.length > 2) return;
  // can only use two decimal places
  if (parts[1] && parts[1].length > 2) return;
  // Parse numeric value
  const numberValue = parseFloat(cleanInput);
  if (isNaN(numberValue)) {
    onChange({target: {value: null}}, null);
    setValue('');
  } else {
    onChange({target: {value: numberValue}}, numberValue);
    setValue(input);
  }
};

// const handleBlur = ({value, setValue, onChange, onBlur}) => e => {
//   console.log('onBlur', value, e);
//   if (typeof value === 'number') {
//     setValue(formatCurrency(value, {symbol: ''}));
//   } else {
//     if (isNaN(parseFloat(value))) {
//       console.log('NAN');
//       setValue('');
//       onChange({target: {value: null}}, null);
//     } else {
//       console.log('setting formatted');
//       setValue(formatCurrency(value, {symbol: ''}));
//     }
//   }
//   // if (onBlur) onBlur(e);
// };

const CurrencyField = ({ 
  value, 
  onChange,
  maxLength = undefined,
  step = '0.01',
  ...props
}) => {
  const [randomId, setRandomId] = useState(Math.random().toString(36).substring(2, 15));
  const [_value, setValue] = useState(
    isNumber(props.defaultValue) || !isNaN(parseFloat(props.defaultValue))
    ? parseFloat(props.defaultValue)
    : 0
  );
  const _onChange = handleChange({ onChange, setValue });
  return (
    <CustomInput id={'currency' + randomId} key={'wrapper-' + randomId} {...omit(props, 'children', 'onBlur')}>
      <TextField
        id={'currency' + randomId}
        key={randomId}
        type="text"
        value={_value}
        onChange={_onChange}
        placeholder="0.00"
        maxLength={maxLength}
        step={step}
        // onBlur={handleBlur({value, setValue, onChange, onBlur: props.onBlur})}
        onFocus={e => console.log('focus', e)}
        style={{
          ...(props?.style || props.fullWidth ? {width: '100%'} : {width: '100px'})
        }}
        sx={{...(props.sx || {})}}
        // startAdornment={
        //   <InputAdornment position="start" style={{color: 'rgb(1,1,1)'}}>$</InputAdornment>
        // }
        InputProps={{
          startAdornment: <InputAdornment position="start" sx={{marginRight: 0, color: 'black'}}>
            <span style={{color: 'rgb(175,175,175)'}}>$</span>
          </InputAdornment>
        }}
        {...omit(props, 'helperText', 'label', 'style', 'sx')}
      />
    </CustomInput>
  );
};

export default CurrencyField;